import { render, staticRenderFns } from "./NewCourseStepper.vue?vue&type=template&id=ef7c6aea"
import script from "./NewCourseStepper.vue?vue&type=script&lang=js"
export * from "./NewCourseStepper.vue?vue&type=script&lang=js"
import style0 from "./NewCourseStepper.vue?vue&type=style&index=0&id=ef7c6aea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports